export const ACTIVE_STATUSES = ["pending", "confirmed", "assigned", "en_route", "arrived", "in_progress"];
export const BOOKED = ["confirmed", "assigned", "en_route", "arrived", "in_progress"];
export const RIDE_TYPES = { one_way: "One-Way", round_trip: "Round Trip", multi_stop: "Multi-Stop", recurring: "Recurring", split_trip: "Split Trip", standard: "Standard", reserved_block: "Reserved block", late_night: "Late night", commuter: "Commuter" };
export const BOOKING_TYPES = { one_way: "One-Way", round_trip: "Round Trip", multi_stop: "Multi-Stop", recurring: "Recurring Ride" };
export const DEFAULT_WAIT_TIERS = [{ max_minutes: 5, fee: 0 }, { max_minutes: 15, fee: 2 }, { max_minutes: 30, fee: 10 }, { max_minutes: 45, fee: 15 }, { max_minutes: 60, fee: 20 }];
export const WAIT_OPTIONS = [0, 5, 10, 15, 20, 30, 45, 60, 90, 120];
export const waitLabel = (min, tiers = DEFAULT_WAIT_TIERS) => {
  const t = [...tiers].sort((a, b) => a.max_minutes - b.max_minutes).find((x) => min <= x.max_minutes);
  const time = min >= 60 && min % 60 === 0 ? `${min / 60} hr${min > 60 ? "s" : ""}` : `${min} min`;
  return `${time} · ${!t ? "admin quote" : t.fee ? `+$${t.fee}` : "free"}`;
};
export const PAYMENT = ["unpaid", "pending", "authorized", "paid", "failed", "refunded"];
export const DECLINE_REASONS = ["Outside service area", "Schedule unavailable", "Pricing review required", "Vehicle unavailable", "Other"];
export const CANCEL_REASONS = ["Customer cancelled", "Driver unavailable", "Vehicle issue", "Schedule conflict", "Outside service area", "Other"];
export const DRIVER_NEXT = {
  assigned: { status: "en_route", label: "En route" },
  en_route: { status: "arrived", label: "Arrived" },
  arrived: { status: "in_progress", label: "Start ride" },
  in_progress: { status: "completed", label: "Complete ride" },
};

export const STATUS_LABEL = {
  pending: "Awaiting approval",
  confirmed: "Confirmed",
  assigned: "Driver assigned",
  en_route: "Driver en route",
  arrived: "Driver arrived",
  in_progress: "In progress",
  completed: "Completed",
  cancelled: "Cancelled",
  declined: "Declined",
  paused: "Paused",
};

export const STATUS_TONE = {
  pending: "bg-amber-400/15 text-amber-300 ring-1 ring-amber-400/40",
  confirmed: "bg-neon-violet/15 text-neon-violet ring-1 ring-neon-violet/40",
  assigned: "bg-neon-cyan/15 text-neon-cyan ring-1 ring-neon-cyan/40",
  en_route: "bg-neon-cyan/15 text-neon-cyan ring-1 ring-neon-cyan/40",
  declined: "bg-white/10 text-white/60 ring-1 ring-white/15",
  arrived: "bg-neon-cyan/15 text-neon-cyan ring-1 ring-neon-cyan/40",
  in_progress: "bg-neon-pink/15 text-neon-pink ring-1 ring-neon-pink/40",
  completed: "bg-neon-lime/15 text-neon-lime ring-1 ring-neon-lime/40",
  cancelled: "bg-white/10 text-white/60 ring-1 ring-white/15",
  paused: "bg-amber-400/10 text-amber-200 ring-1 ring-amber-300/30",
};

export const STEPS = ["pending", "confirmed", "assigned", "en_route", "arrived", "in_progress", "completed"];

export const navUrl = (ride) => {
  const next = ride.status === "in_progress" ? ride.dropoff : ride.pickup;
  const way = ride.status === "in_progress" ? (ride.stops || []).map((s) => `${s.lat},${s.lng}`).join("|") : "";
  return `https://www.google.com/maps/dir/?api=1&destination=${next.lat},${next.lng}${way ? `&waypoints=${encodeURIComponent(way)}` : ""}`;
};

export const money = (n) => (n == null ? "Pending" : `$${Number(n).toFixed(2)}`);

export const isUpcoming = (r) => r.scheduled_at && new Date(r.scheduled_at).getTime() > Date.now() + 60 * 60000;

export const when = (iso) =>
  iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "";

export const CATEGORY_LABEL = {
  university: "University",
  campus: "Campus",
  dorm: "Dorms & campus housing",
  campus_parking: "Campus parking",
  greek: "Greek life",
  apartment: "Apartments",
  neighborhood: "Neighborhoods",
  senior_living: "Senior living",
  hotel: "Hotels",
  restaurant: "Restaurants",
  nightlife: "Bars & nightlife",
  grocery: "Grocery",
  shopping: "Shopping",
  gas: "Gas & convenience",
  travel_stop: "Travel stop",
  medical: "Medical",
  hospital: "Hospital",
  auto: "Auto & towing",
  employer: "Employers & industrial",
  services: "Services & business",
  civic: "Civic & community",
  entertainment: "Entertainment",
  airport: "Airport",
  landmark: "Landmark",
  transit: "Transit",
  other: "Other",
};
